module.exports = new __parcel__URL__("light-bulb.ae4a67fb.svg").toString();